import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";
import { getDrawingData } from "../../BOMTab/DrawingRegisterTab/api";
import { MCSContextProvider } from "../../MCS.context";
import { BOMDashboardContextProvider } from "../../BOMTab/BOMDashboard.context";
import DrawingBomTab from "../../BOMTab/DrawingBom";

export default function BomPage() {
  const { drawingId } = useParams();
  const { plant } = useRoutePlant();
  const [drawing, setDrawing] = useState(null);

  // Header title only - the BOM working set itself is filled by
  // DrawingBomProvider via initialDrawingId below.
  useEffect(() => {
    if (!drawingId) {
      setDrawing(null);
      return;
    }
    let cancelled = false;
    getDrawingData(drawingId)
      .then((data) => {
        if (!cancelled) setDrawing(data ?? null);
      })
      .catch(() => {
        if (!cancelled) setDrawing(null);
      });
    return () => {
      cancelled = true;
    };
  }, [drawingId]);

  const title = drawing?.name
    ? `${drawing.name} - Rev.(${drawing?.revision ?? drawing?.rev ?? ""})`
    : "Drawing BOM";

  return (
    <Box>
      <PageHeader plant={plant} pageTitle={title} />
      <Box sx={{ p: 2 }}>
        {!drawingId ? (
          <Typography variant="body2" color="text.secondary">
            No drawing selected.
          </Typography>
        ) : (
          <MCSContextProvider plant>
            <BOMDashboardContextProvider tabType="bom">
              <DrawingBomTab initialDrawingId={drawingId} />
            </BOMDashboardContextProvider>
          </MCSContextProvider>
        )}
      </Box>
    </Box>
  );
}
